import { httpGet, httpPost } from '../../modules/api/axios_api';
import Constants, { fixProtocol } from '../../constants/constants';

export const getActiveDays = (playerID, startDate, endDate) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/get-home-player-rtm-active-days/${playerID}`);

  const params = new URLSearchParams(url.search);

  params.append('start_date', startDate);
  params.append('end_date', endDate);

  return httpGet(`${url.href}?${params.toString()}`, {}).then((results) => {
    if (results.data.success) {
      return results.data.active_days;
    } else {
      return 0;
    }
  });
};

export const getRemoteTherapyMonitoringPlan = (playerID) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/remote-therapy-monitoring-plan/${playerID}`);
  return httpGet(url.href)
    .then((result) => {
      if (result?.data?.success) {
        return result?.data?.current_plan;
      } else {
        return false;
      }
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      return false;
    });
};

export const updateRemoteTherapyMonitoringPlan = (playerID, newConfig) => {
  const url = new URL(`${fixProtocol(Constants.BACKEND_URL)}/players/remote-therapy-monitoring-plan/${playerID}`);

  const config = {
    config: newConfig,
  };

  return httpPost(url.href, config)
    .then((result) => {
      return result?.data?.success;
    })
    .catch((error) => {
      // eslint-disable-next-line no-console
      console.log(error);
      return false;
    });
};

export const getVideoDuration = (playerId, fromDate, toDate) => {
  const range = fromDate && toDate ? `?from=${Date.parse(fromDate)}&to=${Date.parse(toDate)}` : '';

  const url = new URL(
    `${fixProtocol(Constants.BACKEND_URL)}/players/remote-therapy-monitoring-conference/${playerId}${range}`
  );

  return httpGet(url.href)
    .then((result) => {
      if (result?.data.success) {
        return result.data.data;
      }

      throw Error('Error retrieving conference durations');
    })
    .catch((error) => {
      throw Error(`Error retrieving conference durations: ${error}`);
    });
};
